module.exports = __webpack_public_path__ + "img/abe3902.jpg";